import React from 'react';
import { FormTheme } from '../../types';
import { t } from '../../utils/i18n';

interface SelectProps {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  theme: FormTheme;
  config: Record<string, any>;
}

export const Select: React.FC<SelectProps> = ({
  id, label, required, value, onChange, onFocus, onBlur,
  error, disabled, theme, config,
}) => {
  const inputStyle = theme.inputStyle || 'outlined';
  const options = config.options || [];

  // Los <option> nativos no heredan CSS variables ni soportan transparencia.
  // Aplicamos los colores del tema directamente como inline style.
  const optionStyle: React.CSSProperties = {
    backgroundColor: theme.backgroundColor || '#ffffff',
    color: theme.textColor || '#1F2937',
  };

  return (
    <div className="hexaforms-field">
      <label htmlFor={id} className="hexaforms-label">
        {label}
        {required && <span className="hexaforms-required">*</span>}
      </label>
      <select
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        className={`hexaforms-select hexaforms-input-${inputStyle}${error ? ' hexaforms-select-error' : ''}`}
      >
        <option value="" style={optionStyle}>{config.placeholder || t('select.placeholder')}</option>
        {options.map((option: string | { value: string; label: string }, index: number) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string' ? option : option.label;
          return (
            <option key={index} value={optionValue} style={optionStyle}>
              {optionLabel}
            </option>
          );
        })}
      </select>
      {error && <div className="hexaforms-error">{error}</div>}
    </div>
  );
};
